module.exports = __webpack_public_path__ + "static/media/Bg2.8e7026a8.svg";